<template>
  <div class="flex items-center justify-between gap-2 bg-gray-100 p-2">
    <div class="break-words font-bold">
      <slot />
    </div>
    <div>
      <div v-if="required" class="bg-red-400 text-white text-center text-sm rounded px-2 py-1 w-12">
        必須
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyHeader',
  props: {

    /**
     * 必須
     */
    required: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
